import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import json from "../../assets/survey.json";
import { Model } from "survey-core";
import { QuizService } from '../../Service/Quizservice';
import { ActivatedRoute, Router, UrlSerializer } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import CryptoJS from 'crypto-js';

@Component({
  selector: "creator-page",
  templateUrl: "./creator.page.html",
  styleUrls: ["../app.component.css"],
})
export class CreatorPage {
  json;
  quizid;
  teachername;
  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private QuizService: QuizService, private _snackBar: MatSnackBar) {

  }
  ngOnInit() {
   // json: Model;
    this.teachername = sessionStorage.getItem('teachername');
    if (this.teachername == undefined) {
      this.logout();
    }
    else {
      this.route.queryParams.subscribe(params => {
        this.quizid = (params["qid"]);
      });
      if (this.quizid == undefined) {
        this.json = {
          "pages":
            [{
              "name": "Page1",
              "title": "Quiz Name",
              "description": "Quiz Description"
            }]
        };
      }
      else {
        this.json = JSON.parse(sessionStorage.getItem("editjson"));
      }
    }
    document.getElementById("btnGroupDrop1").innerText = this.teachername;
  }
  onSurveySaved(survey) {
    
    if (survey['pages'][0]["elements"] == undefined ) {
      var snackBarRef = this._snackBar.open("Please Add Some Questions", "ok", {
      });
    }
    else if (survey['pages'][0]["elements"][0].correctAnswer == undefined)
    {
      var snackBarRef = this._snackBar.open("The Correct answer field cannot be empty", "ok", {
      });
    }
    else if(parseInt(survey['pages'][0]["elements"][0].Marks)<0)
    {
      var snackBarRef = this._snackBar.open("Marks Cannot be negative", "ok", {
      });
    }
    else{
      console.log(survey);
      this.json = survey;
      const headers = new HttpHeaders()
        .set('Authorization', 'my-auth-token')
        .set('Content-Type', 'application/json');
      var jsonstr = JSON.parse(JSON.stringify(this.json));
      if (this.quizid == undefined) {

        jsonstr["teacherid"] = sessionStorage.getItem("Td");

        this.QuizService.addjsondata(JSON.stringify(jsonstr))
          .subscribe(data => {
            this.Navigateedit(JSON.parse(JSON.stringify(data))['status'])
          });
      }
      else {
        var updatejson = {
          quizid: CryptoJS.AES.decrypt(this.quizid.trim(), 'q').toString(CryptoJS.enc.Utf8),
          json: this.json
        }
        var sts = this.QuizService.updatejsondata(JSON.stringify(updatejson))
          .subscribe(data => this.Navigateedit(JSON.parse(JSON.stringify(data))['status']));

      }
    }


  }
  Navigateedit(obj) {
    if (obj == "S001") {
      var snackBarRef;
      if (this.quizid == undefined) {
        document.getElementById("svd-save").style.pointerEvents = "none";
        snackBarRef = this._snackBar.open("Quiz Added Successfully", "ok", {
        });
      }
      else {
        snackBarRef = this._snackBar.open("Update Successful", "ok", {
        });
      }
      // this.json = {
      //   "pages": [{
      //     "name": "Page1", "title": "Quiz Name", "description": "Quiz Description"
      //   }]
      // };
      snackBarRef.onAction().subscribe(() => {
        this.router.navigate(['/quizlist'])
      });

    }

  }
  logout() {
    this.router.navigate(["/"]);
    sessionStorage.clear();
  }


  
  
  
}
